import React from 'react';
const journeyMarkers = [{
  label: 'Start',
  top: '0%'
}, {
  label: 'The Problem',
  top: '20%'
}, {
  label: 'The Solution',
  top: '35%'
}, {
  label: 'The Masters',
  top: '50%'
}, {
  label: 'The Offer',
  top: '65%'
}, {
  label: 'Transformation',
  top: '85%'
}];
export function JourneyPath() {
  return <aside aria-label="Page journey" className="pointer-events-none fixed left-8 top-1/2 z-30 hidden -translate-y-1/2 xl:block" data-id="element-188" data-mp="394raiyuz4vvn">
      <div className="relative h-[min(600px,70vh)]" data-id="element-189" data-mp="2v4q9njeplog6">
        <div aria-hidden="true" className="absolute left-1/2 h-full w-px -translate-x-1/2 bg-teal-100" data-id="element-190" data-mp="305nszzbggoj9" />

        {journeyMarkers.map(marker => <div key={marker.label} className="absolute left-1/2 -translate-x-1/2" style={{
        top: marker.top
      }} data-id="element-191" data-mp="2l9etcwnnk96b">
            <div className="group relative pointer-events-auto cursor-help" data-id="element-192" data-mp="2q919peys25jc">
              <div className="h-2.5 w-2.5 rounded-full border-2 border-teal-500 bg-white shadow-sm transition-colors duration-200 group-hover:bg-teal-500" data-id="element-193" data-mp="jh0hofbpc0yc" />
              <div className="absolute left-6 top-1/2 -translate-y-1/2 whitespace-nowrap opacity-0 transition-opacity duration-200 group-hover:opacity-100" data-id="element-194" data-mp="1yrpgc53z7koj">
                <span className="rounded-md border border-teal-100 bg-white px-2 py-1 text-xs font-bold uppercase tracking-widest text-teal-600 shadow-sm" data-id="element-195" data-mp="1tr1sfsb1njyj">
                  {marker.label}
                </span>
              </div>
            </div>
          </div>)}
      </div>
    </aside>;
}